import { create } from 'zustand';

const initialState = {
  principalGroupId: null,
  primaryIdentifier: null,
  cpId: null,
  cpName: null,
  getUser: null,
};

const useProfileSelectionStore = create((set) => ({
  ...initialState,
  actions: {
    setPrincipalGroupId: (principalGroupId) => set(() => ({ principalGroupId })),
    setPrimaryIdentifier: (primaryIdentifier) => set(() => ({ primaryIdentifier })),
    setCpId: (cpId) => set(() => ({ cpId })),
    setCpName: (cpName) => set(() => ({ cpName })),
    setUser: (user) => set(() => ({ user })),
  },
}));

export const useProfileSelectionActions = () => useProfileSelectionStore.getState().actions;
export const usePrincipalGroupId = () => useProfileSelectionStore((state) => state.principalGroupId);
export const usePrimaryIdentifier = () => useProfileSelectionStore((state) => state.primaryIdentifier);
export const useCpId = () => useProfileSelectionStore((state) => state.cpId);
export const useCpName = () => useProfileSelectionStore((state) => state.cpName);
export const useUser = () => useProfileSelectionStore((state) => state.user);
